import $ from "jquery";
import kari from '../../templates/pages/dialog.js';
import { checkNested, getConfig, updateQueryStringParameter } from '../../scripts/general_functions.js';
import language from "../../scripts/translation";

export default function(client) {



    $("body").on("click", ".fullnav__breadcrumb__link", function() {

        let links = decodeURIComponent($(this).attr("data-children"));
        links = JSON.parse(links);

        $(this).parent().nextAll().remove();
        insertMenu(links);


    });


    const res = client,
        logo = res.logo[0],
        style = (logo.inlineStyles && logo.inlineStyles.length > 0 ? "style='" + logo.inlineStyles + "'" : ""),
        cssclass = (logo.cssclass && logo.cssclass.length > 0 ? logo.cssclass : "");



    // console.log("style", logo, logo.cssclass, cssclass);

    document.title = res.name;


    const headerHtml = `
        <nav class="navbar navbar-default navbar-fixed-top header__nav header header__shadow">
          <div class="container-fluid ">
             <div class="row">
                <div class="col-md-12">
                    <div class="header--container">
                        <a href="/" @click="reload">
                            <div class="header__shield-container align-middle">
            			        <img class="header__shield align-middle ${cssclass}" alt="${logo.alttext}" src="${logo.filepath}"  ${style} > 
            			    </div>
        			    </a>
			            <div class="skip-link">
                            <ul>
                                <li>
                                    <a class="skip" href="#maincontent" accesskey="s">${language("HEADER_JUMPMAIN")}</a>
                                </li>
                                <!--li>
                                    <a class="skip" href="#menu_container">${language("HEADER_JUMPNAV")}</a>
                                </li-->
                                <li>
                                    <a class="skip" href="/" accesskey="1">${language("HEADER_JUMPSTART")}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="header__icon-container">
                            <form  onsubmit="return false;">
                                <div class="header__search" role="search">
                                    <div class="header__search__container">
                                        <input type="search" name="searchsite" value="" class="input-control header__search__input" >
                                    </div>
                                    <button class="header__button__dosearch">
                                        <span class="budlight-search"></span>
                                    </button>
                                </div>
                            </form>
                            <button class="header__button__search">
                                <span class="header__button__text">Søk</span>
                                <span class="budlight-search"></span>
                            </button>
                            <button class="header__button__navigation hamburger hamburger--spin" aria-label="Meny" aria-controls="menu_container">
                                <span class="header__button__text">Meny</span>
                                <span class="hamburger-box">
                                    <span class="hamburger-inner"></span>
                                </span>
                            </button>
                            <!--div id="warning__button__container" class="d-inline-block">
                            </div-->
                        </div> 
                    </div>
                </div>
             </div>
          </div>
        </nav>
        
        <div class="fullnav" id="menu_container">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="fullnav__breadcrumb__container">
                            <div class="row fullnav__main"></div>
                        </div>
                        <div class="fullnav__extra"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="chatbot__container " id="chatbot__container"></div>
        <div class="warnings" id="warnings_container"></div>
        <div class="container warnings">
            <div id="warning__button__container" class="d-inline-block"></div>
        </div>
        `;


    document.getElementById("header").innerHTML = headerHtml;

    $("html").on("click", ".header__button__navigation", function(e) {

        $("body,html").scrollTop(0);

        if ($(document).width() < 768) {
            $(".header__button__search").click();
        }
        $(this).toggleClass("is-active");
        $(".header").toggleClass("is-active");

        $(".fullnav").toggle();

        let txt = "Meny";
        if ($(this).hasClass("is-active")) {
            txt = "Lukk"
        }


        $(this).find(".header__button__text").text(txt);

    });

    $("html").on("click", ".header__button__search", function(e) {

        $(this).hide();
        $(".header__button__dosearch").show();

        $(".header__search__input").show(0, function() {
            $(".header__search__input").addClass("is-active").focus().keyup(function(e) {
                let key = e.keyCode || e.which;

                let searchstring = $(this).val();
                if (key === 13 && searchstring.length > 0) {
                    parent.location = "/search/" + searchstring + "?sok=" + searchstring;
                }
            });

        });

        $("html").on("click", ".header__button__dosearch", function(e) {
            let searchstring = $(".header__search__input").val();
            if (searchstring.length > 0) {
                parent.location = "/search/" + searchstring + "?sok=" + searchstring;
            }
        });

        $("body").on("click", ".header__search__input", function(e) {
            e.stopPropagation();
        });

    });


    $("body").on("click", function() {
        if (!$("this").hasClass("header__button__dosearch")) {
            if ($(document).width() > 768) {
                $(".header__button__text.is-active").show();
                $(".header__button__dosearch").hide();
                $(".header__button__search").show();
                $(".header__button__text.is-active").removeClass("is-active");
                $(".header__search__input").hide().removeClass("is-active");
            }
        }

    });



    kari();

    if ($(document).width() < 768) {
        var destination = $(".fullnav__main");
        $(".header__search").insertBefore(destination);
    }
}
